import React from 'react';
import './DispatchBoard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import DriverJobFilledAssignment from './DriverJobFilledAssignment';

export default class DriverJobAssignment extends React.Component {
    getDropId = () => {
        const { jobIndex, assignmentIndex, day } = this.props;
        const dayInt = day.getDay();

        return `staff_${jobIndex}_${dayInt}_${assignmentIndex}`;
    };

    render() {
        const { day, group } = this.props;

        const dayInt = day.getDay();
        const dropId = this.getDropId();

        return (
            <div key={dropId} className="jobAssignment">
                <Droppable droppableId={dropId} style={{ transform: 'none' }}>
                    {(provided, snapshot) => (
                        <div
                            className="assignment-placeholder-row"
                            style={{ minHeight: '50px' }}
                        >
                            <label className="dropPlaceholder my-auto">
                                <FontAwesomeIcon
                                    icon={faUser}
                                    className="mr-1"
                                />
                            </label>
                            <div
                                className={cls('jobAssignmentDropTarget', {
                                    dragging: snapshot.isDraggingOver,
                                    show:
                                        !group.assignment ||
                                        !!snapshot.isDraggingOver,
                                })}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {!!group.assignment && (
                                    <DriverJobFilledAssignment
                                        key={`dfa_${dropId}`}
                                        {...this.props}
                                        dayInt={dayInt}
                                    />
                                )}
                                {
                                    // map qualifying group and roles for display
                                    !group.assignment && (
                                        <div className="dropPlaceholderWrapper">
                                            <label className="dropPlaceholder mr-1">
                                                {group.name}
                                            </label>
                                            {group.assignableGroups.map((g) => (
                                                <span
                                                    title={g.groupName}
                                                    key={g.id}
                                                    className="badge badge-lg badge-secondary mr-1"
                                                >
                                                    {g.groupName
                                                        .charAt(0)
                                                        .toUpperCase()}
                                                </span>
                                            ))}
                                        </div>
                                    )
                                }
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
